import type {InputMaterialConnection} from "#material/sockets/definition"
import type {VectorOutput} from "#material/types/common-return-types"
import {materialConnection} from "#material/nodes/base/connection/shorthand"
import type {VectorMathNodeOperation} from "#material/nodes/converter/vector-math/constants"
import {VectorMath} from "#material/nodes/converter/vector-math/vector-math"
import type {Vec3} from "#material/types/vector"
import {GraphNode} from "@cm/graph-v3"

export function vectorMath(
    operation: VectorMathNodeOperation,
    a: Vec3 | number | undefined | InputMaterialConnection<"vector">,
    b: Vec3 | number | undefined | InputMaterialConnection<"vector"> | InputMaterialConnection<"float">,
): VectorOutput {
    return materialConnection(
        new VectorMath({
            parameters: {
                inputs: {
                    vector: a instanceof GraphNode ? a : undefined,
                    vector_001: b instanceof GraphNode ? b : undefined,
                },
                settings: {
                    operation: operation,
                    vector:
                        a instanceof GraphNode
                            ? undefined
                            : typeof a === "number"
                              ? {
                                    x: a,
                                    y: a,
                                    z: a,
                                }
                              : a,
                    vector_001:
                        b instanceof GraphNode
                            ? undefined
                            : typeof b === "number"
                              ? {
                                    x: b,
                                    y: b,
                                    z: b,
                                }
                              : b,
                },
            },
        }),
        "vector",
    )
}

export function vectorAdd(a: Vec3 | InputMaterialConnection<"vector">, b: Vec3 | InputMaterialConnection<"vector">): VectorOutput {
    return vectorMath("ADD", a, b)
}

export function vectorSub(a: Vec3 | InputMaterialConnection<"vector">, b: Vec3 | InputMaterialConnection<"vector">): VectorOutput {
    return vectorMath("SUBTRACT", a, b)
}

export function vectorMul(
    a: Vec3 | InputMaterialConnection<"vector">,
    b: Vec3 | InputMaterialConnection<"vector"> | number | InputMaterialConnection<"float">,
): VectorOutput {
    return vectorMath("MULTIPLY", a, b)
}

export function normalize(vector: InputMaterialConnection<"vector">): VectorOutput {
    return vectorMath("NORMALIZE", vector, undefined)
}
